import React from 'react';
import ReactDOM from 'react-dom';
import 'nprogress/nprogress.css';
import 'leaflet/dist/leaflet.css';
import {unstable_HistoryRouter as HistoryRouter} from 'react-router-dom';
import App, {history} from './app';
import AuthenticationContext from './contexts/AuthenticationContext';

ReactDOM.render(
    <HistoryRouter history={history}>
        <AuthenticationContext>
            <App />
        </AuthenticationContext>
    </HistoryRouter>,
    document.getElementById('root'),
);
